export default __webpack_public_path__ + "d2445036ecdb33542a3c1680a1a7e713.svg";